import { batchUpdateErrorCodeMap } from './errorCodeMap'
import { mapActions } from 'vuex'
export default {
  data() {
    return {
      selectedList: []
    }
  },
  methods: {
    ...mapActions({
      checkFeedbackExists: 'feedback/checkFeedbackExists',
    }),
    selectionChange(selection) {
      this.selectedList = selection
    },
    // 获取批量操作的operationKey
    getOperationKey(loading = null, selectKey = 'id') {
      if (loading) {
        this[loading] = true
      } else {
        this.$fullLoading.open()
      }
      return new Promise((resolve, reject) => {
        const contentIds = this.selectedList.map((item) => { return item[selectKey] })
        this.$api.resource.getBatchOperationKey(this.spaceId, contentIds).then((data) => {
          return resolve(data)
        }).catch((err) => {
          if (loading) {
            this[loading] = false
          } else {
            this.$fullLoading.close()
          }
          reject(err)
        })
      })
    },
    // 批量操作- 移动
    async batchUpdateClassify(value, evtName = 'moveSpaceComponent') {
      if (!value && value !== 0) {
        this.moveLoading = false
        this.$message.warning('请选择移动项')
        return
      }
      try {
        const operationKey = await this.getOperationKey(null, 'spaceResourceId')
        const params = {
          operationKey,
          spaceCategoryId: this.batchClassifyValue
        }
        this.$api.resource.spaceBatchCategory(this.spaceId, params).then((res) => {
          if (res === true) {
            this.$message.success(`批量移动成功`)
            this.$tracks({
              event: evtName,
              params: { g_c_space_id: this.spaceId, }
            })
            this.search()
            this.closeClassifyDialog()
          }
        }).catch((err) => {
          if (err.code === 'space.resource.name.duplicate') {
            this.$message.error('目标文件夹下存在重名资源')
          } else if (err.code === 'space.resource.update.category.empty.error') {
            this.$message.error('批量移动失败')
          } else {
            this.$matchError(err.code, batchUpdateErrorCodeMap, '移动失败')
          }
        })
      } catch (err) {} finally {
        this.moveLoading = false
        this.$fullLoading.close()
      }
    },
    // 批量操作- 发布/停用
    async batchUpdateStatus(type) {
      try {
        const operationKey = await this.getOperationKey()
        const params = {
          operationKey,
          status: type
        }
        await this.$api.resource.batchOperation.updateStatusBatch(params)
        this.$message.success(`${type === 'online' ? '发布' : '停用'}成功`)
        this.getList()
      } finally {
        this.$fullLoading.close()
      }
    },
    // 批量操作-删除
    batchDelete(evtName = 'deleteSpaceComponent') {
      this.$confirm(`是否确认删除 选中数据？`, { type: 'warning', confirmButtonClass: 'user-confirm', confirmButtonText: '确定删除' }).then(async() => {
        const operationKey = await this.getOperationKey(null, 'id')
        this.$api.resource.deleteResourceBatch(this.spaceId, operationKey).then((res) => {
          if (res === true) {
            this.$fullLoading.close()
            this.$message.success('批量删除成功')
            this.search()
          }
          this.$tracks({
            event: evtName,
            params: { g_c_space_id: this.spaceId, }
          })
        }).finally(() => {
          this.$fullLoading.close()
        })
      }).catch(() => {})
    },
    // 批量操作- 下载构件
    async batchDownload() {
      // 资源批量下载，弹框评分
      this.checkFeedbackExists().catch()
      const operationKey = await this.getOperationKey(null, 'id')
      this.$api.resource.batchDownload(this.spaceId, operationKey).then((res) => {
        if (res.length > 0) {
          res.forEach((v) => {
            this.$downloadMultipleFile(v.downloadUrl, v.name)
          })
          this.$tracks({
            event: 'downloadSpaceComponent',
            params: {
              g_c_space_id: this.spaceId,
              g_c_file_id: res.map((f) => f.id),
              g_c_batch: true,
              g_c_count: res.length
            }
          })
        }
      }).finally((e) => {
        this.$fullLoading.close()
      })
    },
  }
}
